import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { absoluteImageUrl } from "@/components/ImageUploader";
import CoffeeBackground from "@/components/CoffeeBackground";

const DEFAULT_ABOUT = "/backgrounds/talk.jpg";

export const AboutPage = () => {
  const [aboutImage, setAboutImage] = useState("");
  const [aboutText, setAboutText] = useState("");
  const [extraImages, setExtraImages] = useState([]);

  useEffect(() => {
    api
      .get("/site-settings")
      .then((r) => {
        setAboutImage(r.data.about_image || DEFAULT_ABOUT);
        setAboutText(r.data.about_text || "");
        setExtraImages([r.data.about_image_2, r.data.about_image_3].filter(Boolean));
      })
      .catch(() => setAboutImage(DEFAULT_ABOUT));
  }, []);

  return (
    <main data-testid="about-page" className="relative overflow-hidden">
      <CoffeeBackground slot="about" testId="about-bg" />
      <div className="relative mx-auto max-w-4xl px-6 py-24">
      <Seo title="Despre mine" description="Cine este Alexia și de ce scrie fără menajamente despre relații, oameni, bani și viața de adult." />
      <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent)]">Despre mine</p>
      <h1 className="mt-4 font-serif text-5xl font-light leading-tight tracking-tight text-[#F7F1E8] sm:text-6xl">
        Bună, eu sunt <span className="italic text-[var(--coral)]">Alexia</span>.
      </h1>

      <div className="mt-10 grid grid-cols-1 gap-10 md:grid-cols-5">
        <div className="md:col-span-2">
          <div className="rounded-3xl bg-[var(--tint-mint)] p-2">
            {aboutImage ? (
              <img
                src={absoluteImageUrl(aboutImage)}
                alt="Alexia, autoarea blogului La Cafea, Fără Menajamente"
                className="aspect-square w-full rounded-2xl object-cover"
              />
            ) : (
              <div className="aspect-square w-full animate-pulse rounded-2xl bg-[color-mix(in_srgb,var(--teal)_15%,transparent)]" />
            )}
          </div>
          {extraImages.length > 0 && (
            <div className="mt-6 grid grid-cols-2 gap-4" data-testid="about-extra-images">
              {extraImages.map((img, i) => (
                <div
                  key={i}
                  className={`rounded-2xl bg-[#2B1B13] p-1.5 shadow-lg shadow-black/5 ring-1 ring-[color-mix(in_srgb,var(--milk)_14%,transparent)] ${i === 0 ? "-rotate-1" : "rotate-1"}`}
                >
                  <img
                    src={absoluteImageUrl(img)}
                    alt="Amintire aleasă de Alexia"
                    className="aspect-square w-full rounded-xl object-cover"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="md:col-span-3">
          <div className="bloom-prose" data-testid="about-text">
            {aboutText.split(/\n\n+/).filter(Boolean).map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </div>

          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[var(--accent)] px-6 py-3 text-xs font-medium uppercase tracking-[0.2em] text-white transition-transform hover:-translate-y-0.5 active:scale-95"
            data-testid="about-cta"
          >
            Citește ultima însemnare
          </Link>
        </div>
      </div>
      </div>
    </main>
  );
};

export default AboutPage;
